<template>
    <span
        v-if="status"
    >
        {{ getTranslatedStatus }}
    </span>
    <span v-else> - </span>
</template>

<script>
export default {
    name: "MakeEffectiveEmailStatusSlot",
    props: {
        status: {
            type: String,
            required: true
        }
    },
    computed: {
        getTranslatedStatus() {
            switch (this.status) {
                case 'send_to_sendgrid':
                    return 'Envoyé – attente réception';
                case 'delivered':
                    return 'Reçu';
                case 'not_delivered':
                    return 'Echec de livraison';
                case 'blocked':
                    return 'Bloqué';
                case 'deferred':
                    return 'Retardé';
                case 'empty_response_data':
                    return 'Données de réponse vides';
                default:
                    return 'Envoyé – attente réception';
            }
        }
    }
}
</script>
